import React from 'react';
import styled, { keyframes } from 'styled-components';
import { breakPoints, colors } from '../../config';
import PropTypes from 'prop-types';

const defaultBlack = colors.black;

const StyledLogoWrap = styled.div`
        width:270px;
        height:70px;
        position:relative;
        @media (max-width: ${breakPoints.header}px) {
        margin:5px 0;
        }
    `;
const StyledLogo = styled.svg`
        padding: 0;
        @media (max-width: ${breakPoints.header}px) {
            flex: 1;
            text-align:center;
            height:70px;
            width:270px;
        }
    `;
const PathTextP = styled.path`
        fill: ${defaultBlack};
    `;
const PathText = styled.path`
        fill: ${defaultBlack};
    `;
const KfDotBounce = keyframes`
        0% {
            transform: scale(1.0, 1.0);
        }
        50% {
            transform: scale(1.5, 1.5);
        }
        100% {
            transform: scale(1.0, 1.0);
        }
    `;
const KfArrowRot = keyframes`
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(-360deg);
        }
    `;
const KfWink = keyframes`
        0% {
            transform: scale(1.0, 1.0);
        }
        50% {
            transform: scale(1.0, 0);
        }
        100% {
            transform: scale(1.0, 1.0);
        }
    `;
const PathDot = styled.path`
        fill: ${defaultBlack};
        animation-name: ${props => props.isLogoAnimating ? KfDotBounce : 'none'};
        animation-duration: 0.5s;
        animation-iteration-count: 2;
        animation-timing-function: ease-in-out;
`;
const PathDot1 = styled(PathDot)`
        animation-delay: 0.0s;
        transform-origin: 59% 60%;
    `;
const PathDot2 = styled(PathDot)`
        animation-delay: 0.25s;
        transform-origin: 58% 90%;
    `;

const PathEyeL = styled.path`
        fill: white;
    `;
const PathEyeR = styled.path`
        fill: white;
        animation-name: ${props => props.isLogoAnimating ? KfWink : 'none'};
        animation-duration: 0.3s;
        animation-delay: 0.9s;
        animation-iteration-count: 1;
        animation-timing-function: ease-in-out;
        transform-origin: 12% 50%;        
    `;
const PathArrow = styled.path`
        fill: ${defaultBlack};
        animation-duration: 1s;
        animation-iteration-count: 1;
        animation-timing-function: ease-in-out;
        animation-delay: 0.0s;
        transform-origin: 13% 51%;
`;
const PathArrowT = styled(PathArrow)`
        animation-name: ${props => props.isLogoAnimating ? KfArrowRot : 'none'};
    `;
const PathArrowB = styled(PathArrow)`
        animation-name: ${props => props.isLogoAnimating ? KfArrowRot : 'none'};
    `;
const PathBanditMask = styled.path`
        fill: ${defaultBlack};
    `;

const LogoH = ({ isLogoAnimating }) => {

    return <StyledLogoWrap>
        <StyledLogo id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 557.82 145.17">
            <PathArrowB
                isLogoAnimating={isLogoAnimating}
                d="M103.06,134.18l9.49,11.14,2.23-27.74L87,115.36l9.56,11.22a40,40,0,0,1-56.18-4.64l-7.59,6.46A49.93,49.93,0,0,0,103.06,134.18Z"
            />
            <PathBanditMask
                d="M105.9,45.72c-13.56,0-17.18,4.61-34.22,4.77-17-.16-20.67-4.77-34.23-4.77C23.65,45.72,1,55.84,1,75.72s9.39,30,29.27,30S69.12,88.24,69.12,88.24a1.92,1.92,0,0,1,.18-.39,8.11,8.11,0,0,1,2.38-1.11,8.24,8.24,0,0,1,2.38,1.11,3,3,0,0,1,.18.39s19,17.49,38.84,17.49,29.27-10.13,29.27-30S119.71,45.72,105.9,45.72Z"
            />
            <PathEyeR
                isLogoAnimating={isLogoAnimating}
                d="M84.49,76.83s4.36-8.29,16.38-9.27a26.34,26.34,0,0,1,19,6.2s-3.55,7.89-16.14,9.08C89.52,84.19,84.49,76.83,84.49,76.83Z"
            />
            <PathEyeL
                d="M57.21,76s-4.35-8.29-16.38-9.27a26.34,26.34,0,0,0-19,6.2s3.55,7.89,16.14,9.08C52.18,83.4,57.21,76,57.21,76Z"
            />
            <PathArrowT
                isLogoAnimating={isLogoAnimating}
                d="M44.54,14.58,35.06,3.44,32.83,31.18,60.57,33.4,51,22.18a40,40,0,0,1,56.17,4.64l7.6-6.46A49.94,49.94,0,0,0,44.54,14.58Z"
            />
            <PathTextP
                d="M303.5,100.9a4.34,4.34,0,0,0-3.42,1.9,41.73,41.73,0,0,1-7.81,8.12,14.3,14.3,0,0,1-8.56,2.41c-4.61,0-7.93-1.8-10-5.37.07-.19.15-.39.21-.59q14.7-3.66,20.88-9.83a20.5,20.5,0,0,0,6.28-15q0-7.49-4.44-11.86t-11.8-4.38a25.66,25.66,0,0,0-14.77,4.44,30.08,30.08,0,0,0-10.21,12A36.58,36.58,0,0,0,256.19,99a35.76,35.76,0,0,0,1.26,9.81,12.4,12.4,0,0,1-6.84,2.11,11,11,0,0,1-8.06-3.55q-3.48-3.56-7-11.16a44.47,44.47,0,0,0-6.59-10.79,18.88,18.88,0,0,0-9.39-5.32,45.08,45.08,0,0,0,16.36-7.74,34.58,34.58,0,0,0,10.09-12,31,31,0,0,0,3.36-13.89,27.12,27.12,0,0,0-4-14.58A26.53,26.53,0,0,0,233.1,21.75q-8.23-3.67-20.42-3.68-17.51,0-30.88,8.18T161,49.91q-7.41,15.48-7.42,36.78a54.76,54.76,0,0,0,3.56,20.36,31.83,31.83,0,0,0,10.08,14,24,24,0,0,0,15,5q7.74,0,11.54-4.12T198.86,110c.16-.93.59-3.51,1.26-7.74q2.41-14.07,2.92-16.74a11.42,11.42,0,0,1,5.77,2.16,19.94,19.94,0,0,1,4.76,5.9q2.42,4.11,6.6,12.74,5.19,10.79,11,15.22a22.22,22.22,0,0,0,14,4.44,26.67,26.67,0,0,0,14.72-4,44.58,44.58,0,0,0,3.66-2.67q6.64,6.66,18.28,6.66a29.11,29.11,0,0,0,13.76-3,24.69,24.69,0,0,0,9.33-8.5,14.1,14.1,0,0,0,2.15-7.86,7.93,7.93,0,0,0-.95-4.19A2.93,2.93,0,0,0,303.5,100.9ZM205.45,72.23l3.81-21.05a14.83,14.83,0,0,0,.12-2.16q0-6.47-7.23-6.47-9,0-10.65,8.25-1.78,9-3.81,21.43h-3.17A6.54,6.54,0,0,0,180,74a6.17,6.17,0,0,0-2,4.82,7.24,7.24,0,0,0,1.59,4.57c1.06,1.35,3,2,5.9,2l-3.43,19a14.72,14.72,0,0,1-1.71,5.33,3.19,3.19,0,0,1-2.73,1.65c-1.43,0-3-1-4.56-2.92a24.06,24.06,0,0,1-4.06-8.75,51.71,51.71,0,0,1-1.65-14q0-17.39,5.2-29.5t14.52-18.26a38.62,38.62,0,0,1,21.76-6.15q10.51,0,16,4.56T230.31,49A21.27,21.27,0,0,1,227,60.82a23.22,23.22,0,0,1-9,8.12A30.63,30.63,0,0,1,205.45,72.23ZM282.7,78.7a4.66,4.66,0,0,1,3.61,1.46A5.5,5.5,0,0,1,287.64,84q0,4.69-4.31,8.24a28,28,0,0,1-11,5.13,2.53,2.53,0,0,0-.78-.24,25.33,25.33,0,0,1,3.23-13Q278,78.7,282.7,78.7Z"
            />
            <PathText
                d="M556.73,68.36q-2.09-2.08-6.15-2.09a18.54,18.54,0,0,0-9.2,2.92q-5,2.91-10.14,9.7a73,73,0,0,0-9.33,17.57q0-7,.38-13.57,16.88-18.39,24.36-32.16t7.48-26.57q0-8-3.61-13a11.14,11.14,0,0,0-9.45-5q-10.92,0-18.71,14.4t-11.8,35.57a220.11,220.11,0,0,0-4,40.72c0,3.24,0,6.13.11,8.71q-4.73,4.62-8.61,6.13a34,34,0,0,0,.25-3.55,16.41,16.41,0,0,0-2.09-8.18,78.67,78.67,0,0,0-6.15-9.07A47.63,47.63,0,0,1,486,85.17,8.42,8.42,0,0,1,484.63,81a18.08,18.08,0,0,1,2.28-7.73A18.59,18.59,0,0,0,488.3,70a9.28,9.28,0,0,0,.51-2.41,2.11,2.11,0,0,0-1.39-2,13.43,13.43,0,0,0-4.95-.63c-5.07,0-8.42,1.86-10,5.58q-2.79,6.6-5.71,12.74T461.67,93a163.19,163.19,0,0,1-10.53,14.21l-1.65,2a7.85,7.85,0,0,0-1.47,2.67,4.48,4.48,0,0,1-.94.12,3.06,3.06,0,0,1-2.47-1.14,4.57,4.57,0,0,1-.95-3q0-5.72,2.91-20.3,1.9-10,1.91-12.68c0-3-2.08-4.44-6.22-4.44a30.56,30.56,0,0,0-5.58.5,9.16,9.16,0,0,0-1.58-3.86q-1-1.08-3.75-1.08a28.17,28.17,0,0,0-16.55,5.52,39.93,39.93,0,0,0-12.49,14.58,41.24,41.24,0,0,0-4.7,19.22c0,1,.06,1.92.14,2.85l-.83.76c-2.33,2.08-4.34,3.11-6,3.11q-3.67,0-3.68-5.07,0-3.55,2.41-14.59,2.79-12.93,2.79-17.88,0-8.25-8.24-8.25a18.54,18.54,0,0,0-9.2,2.92q-5,2.91-10.14,9.7a72.68,72.68,0,0,0-9.33,17.57q0-7,.38-13.57,16.88-18.39,24.36-32.16t7.48-26.57q0-8-3.62-13a11.13,11.13,0,0,0-9.44-5q-10.92,0-18.71,14.4t-11.8,35.57a220.15,220.15,0,0,0-4,40.72L340,107c-.09,1.61-.13,3.76-.13,6.47q0,7.1,1.21,9.83c.8,1.82,2.47,2.72,5,2.72q9.51,0,11.92-10.14A91.21,91.21,0,0,1,363,101.15a62.18,62.18,0,0,1,6.09-11.22c2-2.84,3.59-4.25,4.69-4.25.93,0,1.39.68,1.39,2a65.45,65.45,0,0,1-1.65,11,79.47,79.47,0,0,0-1.77,12.69q0,7.09,3.3,10.84T384.8,126a23.78,23.78,0,0,0,14-4.31c1-.68,1.94-1.41,2.9-2.18.2.26.38.53.59.79a15.41,15.41,0,0,0,12.55,5.7q10,0,16.62-10.65a17.37,17.37,0,0,0,5.26,7.8,11.88,11.88,0,0,0,7.68,2.85c3.63,0,7.4-1.47,11.29-4.44a63.66,63.66,0,0,0,11-10.9c1.61-1.86,2.41-4.49,2.41-7.87,0-.19,0-.37,0-.56,1.39-2.19,2.8-4.62,4.21-7.3,1.18,1.35,2.45,2.94,3.8,4.75a30.7,30.7,0,0,1,3.36,5.65,16.2,16.2,0,0,1,1.46,6.21c-.76-.08-1.88-.23-3.36-.44a28.11,28.11,0,0,0-3.87-.32c-3.13,0-5.5.81-7.1,2.41a7.8,7.8,0,0,0-2.41,5.71,8.94,8.94,0,0,0,3.49,6.85q3.48,3,10.08,3a18,18,0,0,0,12-4.31,34.28,34.28,0,0,0,14.27-3.11,23,23,0,0,0,3-1.82,13.62,13.62,0,0,0,1.52,3.6,6.38,6.38,0,0,0,5.78,2.85c2.62,0,4.54-.69,5.77-2.09s2.3-4.08,3.23-8a91.21,91.21,0,0,1,4.95-14.72,62.18,62.18,0,0,1,6.09-11.22c2-2.84,3.59-4.25,4.69-4.25.93,0,1.4.68,1.4,2a119.06,119.06,0,0,1-1.53,12.94,127.69,127.69,0,0,0-1.77,16.74q0,4.31,1.9,6.47c1.27,1.44,3.3,2.15,6.09,2.15,3,0,5.09-.69,6.4-2.09s2-3.7,2-6.91a141,141,0,0,1,.76-15.41q.76-6.91,2-14.65a100.1,100.1,0,0,0,1.39-12.43C558.82,71.81,558.13,69.76,556.73,68.36ZM527.94,42.87a110.17,110.17,0,0,1,5.39-17.63c1.86-4.36,3.55-6.53,5.07-6.53,1.1,0,2,.72,2.54,2.15a17,17,0,0,1,.89,6.22q0,8.88-5.14,19.79a90.63,90.63,0,0,1-13,20.16A236.55,236.55,0,0,1,527.94,42.87Zm-166.41,0a110.17,110.17,0,0,1,5.39-17.63c1.86-4.36,3.55-6.53,5.07-6.53,1.1,0,1.95.72,2.54,2.15a17,17,0,0,1,.89,6.22q0,8.88-5.14,19.79a90.63,90.63,0,0,1-13,20.16A233.84,233.84,0,0,1,361.53,42.87Zm66.91,58.28a21.3,21.3,0,0,1-3.68,8.75q-2.53,3.3-5.33,3.3a5.39,5.39,0,0,1-4.38-1.9q-1.57-1.9-1.58-5.83A34.48,34.48,0,0,1,416.13,92a27,27,0,0,1,7.17-10.21,15.39,15.39,0,0,1,9.83-4Z"
            />
            <PathDot1
                isLogoAnimating={isLogoAnimating}
                d="M324.19,89.1c-3.47,0-6.18-.95-8.07-2.81a10.48,10.48,0,0,1-2.93-7.79,10.8,10.8,0,0,1,3.66-8.31A12.34,12.34,0,0,1,325.4,67,11.58,11.58,0,0,1,333,69.53a9.46,9.46,0,0,1,3.29,7.58,11.66,11.66,0,0,1-3.45,8.78A12,12,0,0,1,324.19,89.1Zm1.21-16.66a7.41,7.41,0,0,0-5.24,1.86,5.33,5.33,0,0,0-1.88,4.2,5.14,5.14,0,0,0,1.3,3.84h0c.92.9,2.47,1.36,4.61,1.36a7.22,7.22,0,0,0,5.25-1.81,6.28,6.28,0,0,0,1.78-4.78,3.88,3.88,0,0,0-1.34-3.33A6.8,6.8,0,0,0,325.4,72.44Z"
            />
            <PathDot2
                isLogoAnimating={isLogoAnimating}
                d="M320,125.25c-3.47,0-6.19-1-8.08-2.81a10.48,10.48,0,0,1-2.92-7.8,10.8,10.8,0,0,1,3.66-8.3,12.32,12.32,0,0,1,8.55-3.15,11.61,11.61,0,0,1,7.61,2.49,9.49,9.49,0,0,1,3.29,7.58,11.63,11.63,0,0,1-3.46,8.78A12,12,0,0,1,320,125.25Zm1.21-16.66a7.42,7.42,0,0,0-5.25,1.86,5.32,5.32,0,0,0-1.88,4.19,5.12,5.12,0,0,0,1.31,3.85h0c.91.9,2.47,1.36,4.61,1.36a7.2,7.2,0,0,0,5.24-1.81,6.25,6.25,0,0,0,1.78-4.78,3.88,3.88,0,0,0-1.34-3.33A6.77,6.77,0,0,0,321.22,108.59Z"
            />
        </StyledLogo>
    </StyledLogoWrap>
};

LogoH.propTypes = {
    isLogoAnimating: PropTypes.bool.isRequired,
}
export default LogoH;
